export default __webpack_public_path__ + "static/media/ph.11bfb28d.svg";